import cn from 'classnames'
import { ReactNode, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './PlanningError.module.scss'

interface IPlanningErrorProps {
  text: ReactNode
}

export const PlanningError = ({ text }: IPlanningErrorProps) => {
  const content = useMemo(() => {
    if (typeof text === 'string') {
      return <Translation text={text} span htmlAvailable />
    }
    return text
  }, [text])

  return (
    <div className={styles.root}>
      <i className={cn('kbase kbase-warning-alt', styles.icon)} />
      {content}
    </div>
  )
}
